/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect } from 'react'
import { Row, Col } from 'react-bootstrap-v5'
import { useTranslation } from 'react-i18next'
import { selectLanguage, selectUser, selectReportLink, selectMenuConfig } from 'app/modules/auth'

import { Languages, PageUrl, SideMenuStatus } from 'app/utils/common/constants'
import { useAppSelector } from 'setup/redux/Hooks'
import { AsideMenuItem } from './AsideMenuItem'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItemWithHref } from './AsideMenuItemWithHref'
import { MenuComponent, DrawerComponent } from '../../../assets/ts/components'

export function AsideMenuMain() {
  const { t } = useTranslation()
  const user = useAppSelector(selectUser)
  const lang = useAppSelector(selectLanguage)
  const reportLink = useAppSelector(selectReportLink)
  const menuConfig = useAppSelector(selectMenuConfig)
  // check if the company is in the watan list (comma-separated env)
  const watanIds = (process.env.REACT_APP_WATAN_COMPANY_ID || '')
    .split(',')
    .map((id) => id.trim().toLowerCase())
    .filter(Boolean)
  const isClusterLogic =
    !!user?.companyId && !!user?.isWatanCompany
  useEffect(() => {
    // Reinitialize menu and drawer components after the component mounts
    setTimeout(() => {
      MenuComponent.reinitialization()
      DrawerComponent.reinitialization()
    }, 100)
  }, [])
  return (
    <>
      <div className='menu-item mb-5'>
        <div className='menu-content'>
          <Row>
            <Col sm={4}>
              <img
                width={60}
                height={60}
                className='rounded-circle me-3'
                src={user?.companyLogo}
                alt='b8ak'
              />
            </Col>
            <Col sm={8}>
              <div className='d-flex align-items-center h-100 me-3'>
                <strong className='text-light'>
                  {lang === Languages.en ? user?.companyNameEn : user?.companyNameAr}
                </strong>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <AsideMenuItem
        title={t('ASIDE_MENU.ORDERS_MANAGEMENT')}
        to={PageUrl.TICKET.TICKET_LIST}
        icon='/assets/images/icons/dashboard.svg'
        disabled={menuConfig['ASIDE_MENU.ORDERS_MANAGEMENT'] === SideMenuStatus.DISABLE}
        hide={menuConfig['ASIDE_MENU.ORDERS_MANAGEMENT'] === SideMenuStatus.HIDE}
      />

      <AsideMenuItem
        title={t('ASIDE_MENU.TRIP')}
        to={PageUrl.TRIP.ROOT}
        icon='/assets/images/icons/trip-dashboard.svg'
        disabled={menuConfig['ASIDE_MENU.TRIP'] === SideMenuStatus.DISABLE}
        hide={!isClusterLogic || menuConfig['ASIDE_MENU.TRIP'] === SideMenuStatus.HIDE}
      />

      <AsideMenuItem
        title={t('ASIDE_MENU.ATTENDANCE_DELIVERY')}
        to={PageUrl.TICKET.ATTENDANCE_DELIVERY}
        icon='/assets/images/icons/list-checks.svg'
        disabled={menuConfig['ASIDE_MENU.ATTENDANCE_DELIVERY'] === SideMenuStatus.DISABLE}
        hide={menuConfig['ASIDE_MENU.ATTENDANCE_DELIVERY'] === SideMenuStatus.HIDE}
      />

      <AsideMenuItem
        title={t('ASIDE_MENU.SUBSCRIPTION_CONTRACTS')}
        to={PageUrl.TICKET.SUBSCRIPTION_CONTRACTS}
        icon='/assets/images/icons/list-checks.svg'
        disabled={menuConfig['ASIDE_MENU.SUBSCRIPTION_CONTRACTS'] === SideMenuStatus.DISABLE}
        hide={menuConfig['ASIDE_MENU.SUBSCRIPTION_CONTRACTS'] === SideMenuStatus.HIDE}
      />

      <AsideMenuItem
        title={t('ASIDE_MENU.SERVICES_MANAGEMENT')}
        to={PageUrl.SERVICE_MANAGEMENT.ROOT}
        icon='/assets/images/icons/services-box.svg'
        disabled={menuConfig['ASIDE_MENU.SERVICES_MANAGEMENT'] === SideMenuStatus.DISABLE}
        hide={isClusterLogic || menuConfig['ASIDE_MENU.SERVICES_MANAGEMENT'] === SideMenuStatus.HIDE}
      />

      <AsideMenuItem
        title={t('ASIDE_MENU.FIELD_TEAM_MANAGEMENT')}
        to={PageUrl.USERS.ROOT}
        icon='/assets/images/icons/user.svg'
        disabled={menuConfig['ASIDE_MENU.FIELD_TEAM_MANAGEMENT'] === SideMenuStatus.DISABLE}
        hide={isClusterLogic || menuConfig['ASIDE_MENU.FIELD_TEAM_MANAGEMENT'] === SideMenuStatus.HIDE}
      />

      <AsideMenuItem
        title={t('ASIDE_MENU.BUSY_TIME')}
        to={PageUrl.BUSY_TIME.ROOT}
        icon='/assets/images/icons/calendar-remove.svg'
        disabled={menuConfig['ASIDE_MENU.BUSY_TIME'] === SideMenuStatus.DISABLE}
        hide={!isClusterLogic || menuConfig['ASIDE_MENU.BUSY_TIME'] === SideMenuStatus.HIDE}
      />

      <AsideMenuItemWithSub
        title={t('ASIDE_MENU.OPERATION_SETUP')}
        to='/operation-setup'
        icon='/assets/images/icons/profile-2user.svg'
        svgClass='op-setup-icon'
        hide={!isClusterLogic || menuConfig['ASIDE_MENU.OPERATION_SETUP'] === SideMenuStatus.HIDE}
      >
        <AsideMenuItem
          title={t('ASIDE_MENU.HOUSING')}
          to={PageUrl.OPERATION_SETUP.HOUSING}
          disabled={menuConfig['ASIDE_MENU.HOUSING'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.HOUSING'] === SideMenuStatus.HIDE}
        />
        <AsideMenuItem
          title={t('ASIDE_MENU.ZONES')}
          to={PageUrl.OPERATION_SETUP.ZONES}
          disabled={menuConfig['ASIDE_MENU.ZONES'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.ZONES'] === SideMenuStatus.HIDE}
        />
        <AsideMenuItem
          title={t('ASIDE_MENU.SERVICES')}
          to={PageUrl.SERVICE_MANAGEMENT.ROOT}
          disabled={menuConfig['ASIDE_MENU.SERVICES_MANAGEMENT'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.SERVICES_MANAGEMENT'] === SideMenuStatus.HIDE}
        />
        {/* <AsideMenuItem
          title={t('ASIDE_MENU.SERVICES')}
          to={PageUrl.OPERATION_SETUP.SERVICES}
          disabled={menuConfig['ASIDE_MENU.SERVICES'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.SERVICES'] === SideMenuStatus.HIDE}
        /> */}
        <AsideMenuItem
          title={t('ASIDE_MENU.FIELD_TEAM_MANAGEMENT')}
          to={PageUrl.OPERATION_SETUP.FIELD_TEAM}
          disabled={menuConfig['ASIDE_MENU.FIELD_TEAM_MANAGEMENT'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.FIELD_TEAM_MANAGEMENT'] === SideMenuStatus.HIDE}
        />
        <AsideMenuItem
          title={t('ASIDE_MENU.DISPATCH')}
          to={PageUrl.OPERATION_SETUP.DISPATCH}
          disabled={menuConfig['ASIDE_MENU.DISPATCH'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.DISPATCH'] === SideMenuStatus.HIDE}
        />
      </AsideMenuItemWithSub>

      <AsideMenuItem
        title={t('ASIDE_MENU.CUSTOMERS_MANAGEMENT')}
        to={PageUrl.CUSTOMERS.ROOT}
        icon='/assets/images/icons/user.svg'
        disabled={menuConfig['ASIDE_MENU.CUSTOMERS_MANAGEMENT'] === SideMenuStatus.DISABLE}
        hide={menuConfig['ASIDE_MENU.CUSTOMERS_MANAGEMENT'] === SideMenuStatus.HIDE}
      />

      <AsideMenuItem
        title={t('ASIDE_MENU.REPORTS')}
        to={PageUrl.REPORTS.ROOT}
        icon='/assets/images/icons/column-chart.svg'
        disabled={!reportLink || menuConfig['ASIDE_MENU.REPORTS'] === SideMenuStatus.DISABLE}
        hide={menuConfig['ASIDE_MENU.REPORTS'] === SideMenuStatus.HIDE}
      />

      <AsideMenuItem
        title={t('ASIDE_MENU.GROWTH_AND_MARKETING')}
        to={PageUrl.GROWTH_AND_MARKETING.ROOT}
        icon='/assets/images/icons/trend-up.svg'
        disabled={menuConfig['ASIDE_MENU.GROWTH_AND_MARKETING'] === SideMenuStatus.DISABLE}
        hide={menuConfig['ASIDE_MENU.GROWTH_AND_MARKETING'] === SideMenuStatus.HIDE}
      />

      <AsideMenuItem
        title={t('ASIDE_MENU.AUTOMATION')}
        to={PageUrl.TICKET.AUTOMATION}
        icon='/assets/images/icons/setting.svg'
        disabled={menuConfig['ASIDE_MENU.AUTOMATION'] === SideMenuStatus.DISABLE}
        hide={!isClusterLogic || menuConfig['ASIDE_MENU.AUTOMATION'] === SideMenuStatus.HIDE}
      />

      <AsideMenuItemWithSub
        title={t('ASIDE_MENU.PAYMENTS')}
        to={PageUrl.PAYMENTS.ROOT}
        icon='/assets/images/icons/payment-method.svg'
        hide={!isClusterLogic || menuConfig['ASIDE_MENU.PAYMENTS'] === SideMenuStatus.HIDE}
      >
        <AsideMenuItem
          title={t('ASIDE_MENU.PAYMENT_GATEWAY')}
          to={PageUrl.PAYMENTS.PAYMENT_GATEWAY}
          disabled={menuConfig['ASIDE_MENU.PAYMENT_GATEWAY'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.PAYMENT_GATEWAY'] === SideMenuStatus.HIDE}
        />
        <AsideMenuItem
          title={t('ASIDE_MENU.ZATCA_INTEGRATION')}
          to={PageUrl.PAYMENTS.ZATCA_INTEGRATION}
          disabled={menuConfig['ASIDE_MENU.ZATCA_INTEGRATION'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.ZATCA_INTEGRATION'] === SideMenuStatus.HIDE}
        />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        title={t('ASIDE_MENU.PWA_CONTROL')}
        to='/pwa-control'
        icon='/assets/images/icons/device-message.svg'
        hide={!isClusterLogic || menuConfig['ASIDE_MENU.PWA_CONTROL'] === SideMenuStatus.HIDE}
      >
        <AsideMenuItem
          title={t('ASIDE_MENU.APPEARANCE')}
          to='/pwa-control/appearance'
          disabled={menuConfig['ASIDE_MENU.APPEARANCE'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.APPEARANCE'] === SideMenuStatus.HIDE}
        />
        <AsideMenuItem
          title={t('ASIDE_MENU.OFFERS_MEDIA')}
          to='/pwa-control/offers-media'
          disabled={menuConfig['ASIDE_MENU.OFFERS_MEDIA'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.OFFERS_MEDIA'] === SideMenuStatus.HIDE}
        />
        <AsideMenuItem
          title={t('ASIDE_MENU.SERVICES_CONTROL')}
          to={PageUrl.SERVICE_MANAGEMENT.ROOT}
          disabled={menuConfig['ASIDE_MENU.SERVICES_CONTROL'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.SERVICES_CONTROL'] === SideMenuStatus.HIDE}
        />
        <AsideMenuItem
          title={t('ASIDE_MENU.FEATURES_CARDS')}
          to='/pwa-control/features-cards'
          disabled={menuConfig['ASIDE_MENU.FEATURES_CARDS'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.FEATURES_CARDS'] === SideMenuStatus.HIDE}
        />
        <AsideMenuItem
          title={t('ASIDE_MENU.TERMS_CONDITIONS')}
          to='/pwa-control/terms-conditions'
          disabled={menuConfig['ASIDE_MENU.TERMS_CONDITIONS'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.TERMS_CONDITIONS'] === SideMenuStatus.HIDE}
        />
        <AsideMenuItem
          title={t('ASIDE_MENU.ABOUT_US')}
          to='/pwa-control/about-us'
          disabled={menuConfig['ASIDE_MENU.ABOUT_US'] === SideMenuStatus.DISABLE}
          hide={menuConfig['ASIDE_MENU.ABOUT_US'] === SideMenuStatus.HIDE}
        />
      </AsideMenuItemWithSub>

      <AsideMenuItem
        title={t('ASIDE_MENU.LINKS_MANAGEMENT')}
        to=''
        icon='/assets/images/icons/online-booking.svg'
        disabled={menuConfig['ASIDE_MENU.LINKS_MANAGEMENT'] === SideMenuStatus.DISABLE}
        hide={menuConfig['ASIDE_MENU.LINKS_MANAGEMENT'] === SideMenuStatus.HIDE}
      />

      <AsideMenuItemWithHref
        title={t('ASIDE_MENU.HELP')}
        href='https://wa.me/00966550831611'
        icon='/assets/images/icons/phone-right.svg'
        target='_blank'
      />

      {/* <AsideMenuItemWithSub
				title={t('ASIDE_MENU.SERVICE')}
				to='/crafted/widgets'
				icon='/assets/images/icons/box.svg'
				fontIcon='bi-layers'
				hide
			>
				<AsideMenuItem to='/error/404' title={t('ASIDE_MENU.SERVICE')} hasBullet={true} />
			</AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        title={t('ASIDE_MENU.REPORT')}
        to='/error'
        fontIcon='bi-sticky'
        icon='/assets/images/icons/city.svg'
        hide
      >
        <AsideMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <AsideMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItem
        title={t('ASIDE_MENU.CUSTOMER_REVIEW')}
        to='/sample-page'
        icon='/assets/images/icons/message.svg'
        fontIcon='bi-layers'
        badgeCount={4}
        hide
      />

      <AsideMenuItem
        title={t('ASIDE_MENU.SETTING')}
        to='/sample-page'
        icon='/assets/images/icons/setting.svg'
        fontIcon='bi-layers'
        hide
      />

      <AsideMenuItem
        title={t('ASIDE_MENU.SUPPORT')}
        to='/sample-page'
        icon='/assets/images/icons/phone.svg'
        fontIcon='bi-layers'
        hide
      />
       */}
    </>
  )
}
